import * as React from 'react';
import {Link} from 'react-router-dom';
import {GridRow, GridRowProps} from '@mui/x-data-grid';

/**
 * Optional function to generate the link's path based on the row data.
 * If provided, the row will be wrapped in a Link component, making it clickable.
 * @param {any} row - The data for the current row.
 * @returns {string} The path for the link.
 */
export interface ClickableRowProps extends GridRowProps {
  getHref?: (row: any) => string;
}

/**
 * A custom row component for the MUI Data Grid that makes the row clickable if a `getHref` function is provided.
 *
 * When `getHref` is provided, the row is wrapped in a `Link` component from `react-router-dom`,
 * allowing navigation to a different page when the row is clicked.
 *
 * @param {ClickableRowProps} props - The props for the ClickableRow component.
 * @returns {React.ReactElement} A GridRow component, wrapped in a Link if `getHref` is provided.
 */
export const ClickableRow = (props: ClickableRowProps) => {
  const {getHref, ...otherProps} = props;

  if (!getHref) {
    return <GridRow {...otherProps} />;
  }

  const path = getHref(props.row);

  return (
    <a href={path} style={{textDecoration: 'none', color: 'inherit'}}>
      <GridRow {...otherProps} />
    </a>
  );
};

export default ClickableRow;
